// Browser-tab title for a screen: "<Screen> · Qbuy360", the pattern the rest of
// the suite uses. public/index.html used to carry the legacy name for every
// screen; the router now sets the title from the path.
export const PRODUCT_TITLE = "Qbuy360";

// First path segment -> screen name. Routes with an id (/bom-tool/:id, ...) are
// matched on their first segment, so they title like their list.
const SCREENS = {
  "": "Sign in",
  register: "Create account",
  "forgot-password": "Reset password",
  "verify-email": "Verify email",
  onboarding: "Onboarding",
  "get-started": "Get started",
  auth: "Admin sign in",
  "bom-column-mapping": "Column mapping",
  "bom-tool": "BOM tool",
  orders: "Orders",
  "sales-order-history": "Sales order history",
  "my-orders": "Order detail",
  dashboard: "Dashboard",
  cart: "Cart",
  "uploaded-bom": "Uploaded BOMs",
  search: "Search",
  "bom-analysis": "BOM analysis",
  shipments: "Shipments",
  history: "History",
  suppliers: "Suppliers",
  analytics: "Analytics",
  settings: "Settings",
  users: "Users",
  profile: "Profile",
  "bom-ai": "BOM AI",
};

export function screenTitle(pathname) {
  const parts = String(pathname || "/").split("/").filter(Boolean);
  const first = parts[0] || "";
  // "auth" is only a screen as /auth/company/admin-login; any other /auth/... is unknown.
  const known =
    Object.prototype.hasOwnProperty.call(SCREENS, first) &&
    (first !== "auth" || parts.join("/") === "auth/company/admin-login");
  const screen = known ? SCREENS[first] : "Page not found";
  return `${screen} · ${PRODUCT_TITLE}`;
}
